import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledErrorTooltip = styled(Tooltip)({
  '& .MuiTooltip-tooltip': {
    backgroundColor: 'white',
    color: 'var(--error)',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
    border: '1px solid var(--error)',
    fontSize: '14px',
    fontFamily: 'Outfit',
  },
  '& .MuiTooltip-arrow': {
    color: 'white',
    '&::before': {
      border: '1px solid var(--error)',
    },
  },
});
